<script>
  import { useLocation } from "svelte-navigator";

  const location = useLocation();

  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['disableCookies']);  
  _paq.push(['enableLinkTracking']);
  (function() {
    var u="https://transmediale.matomo.cloud/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '1']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.type='text/javascript'; g.async=true; g.src='//cdn.matomo.cloud/transmediale.matomo.cloud/matomo.js'; s.parentNode.insertBefore(g,s);
  })();

  export function trackPageView(location) {
    _paq.push(['setCustomUrl', location]);
    //_paq.push(['setDocumentTitle', 'My New Title']);
    _paq.push(['trackPageView']);
  }

  let lastLocation = null

  $: {
    if (lastLocation?.pathname !== $location.pathname) {
      // console.log("track " + $location.pathname)
      trackPageView($location.pathname)
    }
    lastLocation = $location
  }

</script>
